module.exports = __webpack_public_path__ + "img/7.6abf8b18.svg";